module.exports = __webpack_public_path__ + "static/media/creatopy.c01c6279.svg";